var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("transition", { attrs: { name: "wa-modal-fade" } }, [
        _vm.visible
          ? _c(
              "div",
              {
                staticClass: "wa-modal-overlay",
                on: { click: _vm.handleOverlayClick },
              },
              [
                _c(
                  "div",
                  {
                    staticClass: "wa-modal-container",
                    on: {
                      click: function ($event) {
                        $event.stopPropagation()
                      },
                    },
                  },
                  [
                    _c(
                      "button",
                      {
                        staticClass: "wa-modal-close",
                        on: { click: _vm.handleCancel },
                      },
                      [
                        _c("span", { staticClass: "material-icons" }, [
                          _vm._v("close"),
                        ]),
                      ]
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "wa-modal-wrapper" }, [
                      _c("div", { staticClass: "wa-modal-header" }, [
                        _c("h2", [
                          _vm._v(_vm._s(_vm.$t("message.whatsappIntegration"))),
                        ]),
                        _vm._v(" "),
                        _c("p", [
                          _vm._v(
                            _vm._s(
                              _vm.$t("message.whatsappIntegrationSubtitle")
                            )
                          ),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "wa-modal-body" }, [
                        _c("div", { staticClass: "wa-solutions-grid" }, [
                          _c(
                            "div",
                            { staticClass: "wa-solution-card wa-v3-card" },
                            [
                              _c("div", { staticClass: "wa-card-icon" }, [
                                _c(
                                  "div",
                                  { staticClass: "wa-icon-circle whatsapp-bg" },
                                  [
                                    _c("WhatsappV3Icon", {
                                      attrs: { color: "#fff" },
                                    }),
                                  ],
                                  1
                                ),
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "wa-card-content" }, [
                                _c("h3", [
                                  _vm._v(_vm._s(_vm.$t("message.whatsappV3"))),
                                ]),
                                _vm._v(" "),
                                _c("p", { staticClass: "wa-card-subtitle" }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t("message.qrCodeAdvancedFeatures")
                                    )
                                  ),
                                ]),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "wa-features-section" },
                                  [
                                    _c("div", { staticClass: "wa-pros" }, [
                                      _c("h4", [
                                        _c(
                                          "span",
                                          { staticClass: "icon-check" },
                                          [_vm._v("✓")]
                                        ),
                                        _vm._v(
                                          " " +
                                            _vm._s(_vm.$t("message.advantages"))
                                        ),
                                      ]),
                                      _vm._v(" "),
                                      _c("ul", [
                                        _c("li", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t("message.quickQrSetup")
                                            )
                                          ),
                                        ]),
                                        _vm._v(" "),
                                        _c("li", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t("message.messageQuoting")
                                            )
                                          ),
                                        ]),
                                        _vm._v(" "),
                                        _c("li", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                "message.newsletterChannels"
                                              )
                                            )
                                          ),
                                        ]),
                                        _vm._v(" "),
                                        _c("li", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t("message.getProfilePhoto")
                                            )
                                          ),
                                        ]),
                                      ]),
                                    ]),
                                    _vm._v(" "),
                                    _c("div", { staticClass: "wa-cons" }, [
                                      _c("h4", [
                                        _c(
                                          "span",
                                          { staticClass: "icon-cross" },
                                          [_vm._v("✕")]
                                        ),
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm.$t("message.limitations")
                                            )
                                        ),
                                      ]),
                                      _vm._v(" "),
                                      _c("ul", [
                                        _c("li", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t("message.deviceBased")
                                            )
                                          ),
                                        ]),
                                        _vm._v(" "),
                                        _c("li", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t("message.banRiskContinues")
                                            )
                                          ),
                                        ]),
                                        _vm._v(" "),
                                        _c("li", [
                                          _vm._v(
                                            _vm._s(_vm.$t("message.lowSla"))
                                          ),
                                        ]),
                                      ]),
                                    ]),
                                  ]
                                ),
                              ]),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "wa-solution-card wa-api-card" },
                            [
                              _c("div", { staticClass: "wa-card-icon" }, [
                                _c(
                                  "div",
                                  { staticClass: "wa-icon-circle whatsapp-bg" },
                                  [
                                    _c("WhatsappBusinessIcon", {
                                      attrs: { color: "#fff" },
                                    }),
                                  ],
                                  1
                                ),
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "wa-card-content" }, [
                                _c("h3", [
                                  _vm._v(
                                    _vm._s(_vm.$t("message.whatsappWaba"))
                                  ),
                                ]),
                                _vm._v(" "),
                                _c("p", { staticClass: "wa-card-subtitle" }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t("message.metaCloudApiSolution")
                                    )
                                  ),
                                ]),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "wa-features-section" },
                                  [
                                    _c("div", { staticClass: "wa-pros" }, [
                                      _c("h4", [
                                        _c(
                                          "span",
                                          { staticClass: "icon-check" },
                                          [_vm._v("✓")]
                                        ),
                                        _vm._v(
                                          " " +
                                            _vm._s(_vm.$t("message.advantages"))
                                        ),
                                      ]),
                                      _vm._v(" "),
                                      _c("ul", [
                                        _c("li", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                "message.metaApprovedSolution"
                                              )
                                            )
                                          ),
                                        ]),
                                        _vm._v(" "),
                                        _c("li", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t("message.sla99Guarantee")
                                            )
                                          ),
                                        ]),
                                        _vm._v(" "),
                                        _c("li", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                "message.restApiTemplateMessages"
                                              )
                                            )
                                          ),
                                        ]),
                                        _vm._v(" "),
                                        _c("li", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                "message.broadcastAndAutomation"
                                              )
                                            )
                                          ),
                                        ]),
                                      ]),
                                    ]),
                                    _vm._v(" "),
                                    _c("div", { staticClass: "wa-cons" }, [
                                      _c("h4", [
                                        _c(
                                          "span",
                                          { staticClass: "icon-cross" },
                                          [_vm._v("✕")]
                                        ),
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm.$t("message.limitations")
                                            )
                                        ),
                                      ]),
                                      _vm._v(" "),
                                      _c("ul", [
                                        _c("li", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                "message.whatsappUnusableOnPhone"
                                              )
                                            )
                                          ),
                                        ]),
                                        _vm._v(" "),
                                        _c("li", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t("message.chatHistoryLost")
                                            )
                                          ),
                                        ]),
                                        _vm._v(" "),
                                        _c("li", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t("message.apiMessageFee")
                                            )
                                          ),
                                        ]),
                                      ]),
                                    ]),
                                  ]
                                ),
                              ]),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "wa-solution-card wa-coex-card" },
                            [
                              _c("div", { staticClass: "wa-card-icon" }, [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "wa-icon-circle whatsapp-coex-bg",
                                  },
                                  [
                                    _c("WhatsappBusinessIcon", {
                                      attrs: { color: "#fff" },
                                    }),
                                  ],
                                  1
                                ),
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "wa-card-content" }, [
                                _c("h3", [
                                  _vm._v(_vm._s(_vm.$t("message.wabaCoex"))),
                                ]),
                                _vm._v(" "),
                                _c("p", { staticClass: "wa-card-subtitle" }, [
                                  _vm._v(
                                    _vm._s(_vm.$t("message.appAndApiTogether"))
                                  ),
                                ]),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "wa-features-section" },
                                  [
                                    _c("div", { staticClass: "wa-pros" }, [
                                      _c("h4", [
                                        _c(
                                          "span",
                                          { staticClass: "icon-check" },
                                          [_vm._v("✓")]
                                        ),
                                        _vm._v(
                                          " " +
                                            _vm._s(_vm.$t("message.advantages"))
                                        ),
                                      ]),
                                      _vm._v(" "),
                                      _c("ul", [
                                        _c("li", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                "message.phoneAndApiTogether"
                                              )
                                            )
                                          ),
                                        ]),
                                        _vm._v(" "),
                                        _c("li", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                "message.chatHistoryPreserved"
                                              )
                                            )
                                          ),
                                        ]),
                                        _vm._v(" "),
                                        _c("li", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t("message.messageEcho")
                                            )
                                          ),
                                        ]),
                                        _vm._v(" "),
                                        _c("li", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t("message.appMessagesFree")
                                            )
                                          ),
                                        ]),
                                      ]),
                                    ]),
                                    _vm._v(" "),
                                    _c("div", { staticClass: "wa-cons" }, [
                                      _c("h4", [
                                        _c(
                                          "span",
                                          { staticClass: "icon-cross" },
                                          [_vm._v("✕")]
                                        ),
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm.$t("message.limitations")
                                            )
                                        ),
                                      ]),
                                      _vm._v(" "),
                                      _c("ul", [
                                        _c("li", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t("message.apiMessageFee")
                                            )
                                          ),
                                        ]),
                                        _vm._v(" "),
                                        _c("li", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                "message.broadcastListsDisabled"
                                              )
                                            )
                                          ),
                                        ]),
                                        _vm._v(" "),
                                        _c("li", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t("message.groupsNoApiSync")
                                            )
                                          ),
                                        ]),
                                      ]),
                                    ]),
                                  ]
                                ),
                              ]),
                            ]
                          ),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "wa-info-banner" }, [
                          _c("span", { staticClass: "material-icons" }, [
                            _vm._v("info"),
                          ]),
                          _vm._v(" "),
                          _c("p", [
                            _vm._v(
                              "\n                            " +
                                _vm._s(_vm.$t("message.wabaCoexInfoBanner")) +
                                "\n                        "
                            ),
                          ]),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "wa-modal-footer" }, [
                        _c(
                          "button",
                          {
                            staticClass: "wa-btn wa-btn-link",
                            on: { click: _vm.handleDetailedComparison },
                          },
                          [
                            _c("span", { staticClass: "material-icons" }, [
                              _vm._v("compare_arrows"),
                            ]),
                            _vm._v(
                              "\n                        " +
                                _vm._s(_vm.$t("message.detailedComparison")) +
                                "\n                    "
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c("div", { staticClass: "wa-footer-actions" }, [
                          _c(
                            "button",
                            {
                              staticClass: "wa-btn wa-btn-secondary",
                              on: { click: _vm.handleCancel },
                            },
                            [
                              _vm._v(
                                "\n                            " +
                                  _vm._s(_vm.$t("message.cancel")) +
                                  "\n                        "
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "button",
                            {
                              staticClass: "wa-btn wa-btn-primary",
                              on: { click: _vm.handleAccept },
                            },
                            [
                              _vm._v(
                                "\n                            " +
                                  _vm._s(_vm.$t("message.approveAndContinue")) +
                                  "\n                        "
                              ),
                            ]
                          ),
                        ]),
                      ]),
                    ]),
                  ]
                ),
              ]
            )
          : _vm._e(),
      ]),
      _vm._v(" "),
      _c("transition", { attrs: { name: "wa-modal-fade" } }, [
        _vm.showDetailedModal
          ? _c(
              "div",
              {
                staticClass: "wa-detailed-modal-overlay",
                on: { click: _vm.closeDetailedModal },
              },
              [
                _c(
                  "div",
                  {
                    staticClass: "wa-detailed-modal-container",
                    on: {
                      click: function ($event) {
                        $event.stopPropagation()
                      },
                    },
                  },
                  [
                    _c(
                      "button",
                      {
                        staticClass: "wa-modal-close",
                        on: { click: _vm.closeDetailedModal },
                      },
                      [
                        _c("span", { staticClass: "material-icons" }, [
                          _vm._v("close"),
                        ]),
                      ]
                    ),
                    _vm._v(" "),
                    _c("WhatsappComparison"),
                  ],
                  1
                ),
              ]
            )
          : _vm._e(),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }